import React from "react";
import { useForm, Controller } from "react-hook-form";
import { customerData, executiveData } from "../globalApi/Api";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
const SelectPopup = ({ isOpen, closePopup, type }) => {
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const { state } = useLocation();

  // GET API START FOR EXECUTIVE
  const {
    data: executiveDetails,
    isLoading: executiveLoading,
    refetch: executiveRefetch,
  } = useQuery("executive", executiveData, {
    refetchOnWindowFocus: false,
  });

  // GET API END FOR EXECUTIVE

  const executives = executiveDetails?.data;

  const executiveNames = executives?.map((data) => {
    return `${data?.executiveName} : ${data?.phoneNumber}`;
  });

  // GET API START FOR CUSTOMERS
  const {
    data: customerDetails,
    isLoading: customerLoading,
    refetch: cutomerRefetch,
  } = useQuery("customer", customerData, {
    refetchOnWindowFocus: false,
  });

  // GET API END FOR CUSTOMERS

  let customerLevel = customerDetails?.data;

  let customerRoute = customerDetails?.data;

  const onSubmit = (data) => {
    // Only executiveName and salesDate are required for the reports
    const formData = {
      executiveName: data?.executiveName,
      salesDate: data?.salesDate
        ? new Date(data.salesDate).toISOString().split("T")[0]
        : null,
    };

    if (formData?.executiveName && formData?.salesDate) {
      if (type === "product out") {
        navigate("/productInvoice", { state: formData });
      } else {
        navigate("/orderInvoice", { state: formData });
      }
    } else {
      console.warn("Missing executive name or sales date.");
    }
  };

  if (!isOpen) return null;
  return (
    <>
      <div className="popup-overlay" onClick={closePopup}>
        <div
          className="popup"
          onClick={(e) => e.stopPropagation()}
          style={{
            height: "auto",
            width: "500px",
          }}
        >
          <form style={{ width: "100%" }} onSubmit={handleSubmit(onSubmit)}>
            <div className="row mb-4">
              <div className="col-4">
                <label className="executive_label">Sales Date</label>
              </div>
              <div className="col-8">
                <Controller
                  name="salesDate"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="date"
                      className="product_input_field"
                      placeholder="Select Sales Date"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-4">
                <label className="executive_label">Executive Name</label>
              </div>
              <div className="col-8">
                <Controller
                  name="executiveName"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <>
                      <input
                        {...field}
                        list="executive-list"
                        className="product_input_field"
                        placeholder="Select executive"
                      />
                      <datalist id="executive-list">
                        {executives?.map((data, index) => (
                          <option key={index} value={data?.executiveName}>
                            {`${data?.executiveName} : ${data?.phoneNumber}`}
                          </option>
                        ))}
                      </datalist>
                    </>
                  )}
                />
              </div>
            </div>
            <div className="row my-3">
              <div className="col-4"></div>
              <div className="col-8">
                <button
                  type="submit"
                  className="popup_ok_cancel_btn"
                  style={{ width: "100%" }}
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SelectPopup;
